import { initElmApp } from 'elm/utilities'
import * as ManageRoles from 'elm/src/ManageRoles.elm'

export function init (): null {
  const app = initElmApp(ManageRoles)

  app.ports.showAlertDialog.subscribe((subscriptionId: string) => {
    const shouldDeleteSubscription: boolean = window.confirm('Are you sure?')

    if (shouldDeleteSubscription) {
      app.ports.shouldDeleteSubscription.send(subscriptionId)
    }
  })

  const bodyElement = document.querySelector('body')

  const debouncedScrollHandler = _.debounce(() => {
    const scrollPosition = bodyElement.scrollTop + bodyElement.clientHeight
    const scrollHeight = bodyElement.scrollHeight

    if (scrollPosition >= scrollHeight) {
      app.ports.loadMore.send(null)
    }
  }, 300)

  bodyElement.addEventListener('scroll', debouncedScrollHandler)
}
